import React from "react";

export const TaskPreviewContext = React.createContext({
  enabled: false,
  firstN: 3,
  fixedTaskIndex: null,
});
